import React from "react";

function BotAlgorithm() {
  return (
    <>
      <div
        className="process-style-two-area overflow-hidden bg-cover default-padding bg-dark text-light"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-20.jpg)",
        }}
      >
        <div className="container">
          <div className="site-heading">
            <div className="row align-center">
              <div className="col-lg-6">
                <h4 className="sub-title">Our Process</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Our Crypto Trading Bot Development Process
                </h2>
              </div>
              {/* <div className="col-lg-5 offset-lg-1">
                <p>
                  At Xeer Technology, we specialize in building highly secure,
                  scalable, and user-centric cryptocurrency wallets. From a
                  developer's perspective, our crypto wallets are designed to
                  deliver cutting-edge functionalities that ensure seamless
                  digital asset management while maintaining robust security
                  protocols. Key features include:
                </p>
              </div> */}
            </div>
          </div>
        </div>
        <div className="container">
          <div className="process-style-two-items">
            <div className="row">
              <div className="col-lg-3 col-md-6 process-two-single">
                <div className="process-style-two-item">
                  <span>01</span>
                  <h4>Consultation & Strategy Development</h4>
                  <p>
                    We begin by understanding your trading goals and defining a
                    bot strategy tailored to meet your requirements.
                  </p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 process-two-single">
                <div className="process-style-two-item">
                  <span>02</span>
                  <h4>Bot Algorithm Design & Development</h4>
                  <p>
                    Our developers create custom algorithms, integrating them
                    with the latest data feeds and AI-powered analytics for
                    real-time performance.
                  </p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 process-two-single">
                <div className="process-style-two-item">
                  <span>03</span>
                  <h4>Testing & Quality Assurance</h4>
                  <p>
                    Rigorous testing and backtesting ensure the bot’s
                    reliability, accuracy, and performance before it goes live.
                  </p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 process-two-single">
                <div className="process-style-two-item">
                  <span>04</span>
                  <h4>Deployment & Ongoing Support</h4>
                  <p>
                    We assist with setup, provide training, and offer continuous
                    support and updates to keep your bot optimized for evolving
                    market conditions.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BotAlgorithm;
